import React, { Fragment } from "react";
import { JustificationCard } from "../../components/About/JustificationCard";
import { PageHero } from "../../components/Global/PageHero";
import { BackToTop } from "../../templates/BackToTop";

export const BibleJustification = () => (
  <Fragment>
    <PageHero
      eyebrow="Doctrine"
      title="Biblical"
      highlight="Justification"
      subtitle={'“The Bible says ye shall know the truth and the truth shall make you free” — John 8:32'}
    />
    <JustificationCard />
    <BackToTop />
  </Fragment>
);
